module.exports = "<span class=\"image\"\n      [ngStyle]=\"style\"\n      [ngClass]=\"size\"\n      *ngIf=\"active\"\n      >\n\n</span>\n"